import { useCallback } from 'react';
import { useWindowSize } from '@hooks/useWindowSize';

/*
 * Prefer var(--column-amount) to this function to avoid flashes on page load
 * If calculating grid column width, use calc(((100% - ((var(--columns) - 1) * var(--gap))) / var(--columns)))
 * Use useColumnAmount() to get the amount of columns to use in js
 * Example: to decide if we should show arrows in GridCarousel
 * */
export function useCarouselColumnAmount({ columnType }: { columnType: 'default' | 'large' }) {
  const { width: windowWidth } = useWindowSize();

  const getColumnAmount = useCallback(() => {
    if (windowWidth === null) return 4;

    if (columnType === 'large') {
      if (windowWidth >= 1280) return 4;
      if (windowWidth >= 768) return 3;
      if (windowWidth >= 640) return 2.5;
    }

    if (windowWidth >= 1280) return 5;
    if (windowWidth >= 1024) return 4;
    if (windowWidth >= 768) return 3;
    if (windowWidth >= 640) return 2.5;
    return 1.5;
  }, [windowWidth, columnType]);

  return getColumnAmount();
}

/*
 * Used for grids that aren't carousels
 * Since user can't slide, we want to show complete items
 * */
export function useGridColumnAmount() {
  const width = typeof window === 'undefined' ? 0 : window.innerWidth;

  const getColumnAmount = useCallback(() => {
    if (width >= 1280) return 4;
    if (width >= 768) return 3;
    if (width >= 640) return 3;
    return 2;
  }, [width]);

  if (typeof window === 'undefined') return 4;

  return getColumnAmount();
}
